<div class="data-item d-flex flex-column justify-content-center align-items-center {{bgColor}}">
  <gray-icon class="mb-2" icon="{{icon}}"></gray-icon>
  <p class="fs-small fw-400 color-gray-400 mb-1">{{subject}}</p>
  <p class="fs-large fw-800 color-gray-950">{{value}}</p>
</div>
